import { BillingStrategy as PricingPlanBillingStrategy } from '@vendasta/billing';

export enum BillingStrategy {
  Invalid = 'INVALID',
  EndOfPeriod = 'END_OF_PERIOD',
  StartOfPeriod = 'START_OF_PERIOD',
  Instantly = 'INSTANTLY',
  EndOfDay = 'END_OF_DAY',
}

export function isBillingStrategyInstant(strategy: BillingStrategy): boolean {
  return strategy === BillingStrategy.Instantly || strategy === BillingStrategy.EndOfDay;
}

export function billingStrategyFromAPI(bsAPI: PricingPlanBillingStrategy | undefined): BillingStrategy {
  switch (bsAPI) {
    case PricingPlanBillingStrategy.BILLING_STRATEGY_END_OF_PERIOD:
      return BillingStrategy.EndOfPeriod;
    case PricingPlanBillingStrategy.BILLING_STRATEGY_START_OF_PERIOD:
      return BillingStrategy.StartOfPeriod;
    case PricingPlanBillingStrategy.BILLING_STRATEGY_INSTANTLY:
      return BillingStrategy.Instantly;
    case PricingPlanBillingStrategy.BILLING_STRATEGY_END_OF_DAY:
      return BillingStrategy.EndOfDay;
  }
  return BillingStrategy.Invalid;
}

export function billingStrategyToAPI(strategy: BillingStrategy | undefined): PricingPlanBillingStrategy {
  switch (strategy) {
    case BillingStrategy.EndOfPeriod:
      return PricingPlanBillingStrategy.BILLING_STRATEGY_END_OF_PERIOD;
    case BillingStrategy.StartOfPeriod:
      return PricingPlanBillingStrategy.BILLING_STRATEGY_START_OF_PERIOD;
    case BillingStrategy.Instantly:
      return PricingPlanBillingStrategy.BILLING_STRATEGY_INSTANTLY;
    case BillingStrategy.EndOfDay:
      return PricingPlanBillingStrategy.BILLING_STRATEGY_END_OF_DAY;
  }
  return PricingPlanBillingStrategy.BILLING_STRATEGY_NONE;
}
